<page-load-header *ngIf="!initialized"></page-load-header>

<div class="cs_container">
  <div class="cs_header">
    <div class="cs_info-container">
      <div class="cs_info-item">
        <div class="cs_label">Email:</div>
        <div class="cs_value">{{analysis.publicUserEmail}}</div>
      </div>
      <div class="cs_info-item">
        <div class="cs_label">Date:</div>
        <div class="cs_value">{{analysis.dateTime | date:'short' }}</div>
      </div>
    </div>
    <div class="cs_logo-container">
      <a href="https://rundna.com/" target="_blank"><img class="cs_logo" src="../../../../assets/img/assessment/logo.png" alt="" /></a>
    </div>
  </div>

  <!--IN FAILED-->
  <div *ngIf="analysis.status == assessmentAiStatus.Failed" class="cs_main cs_bg">
    <div *ngFor="let item of videoProposedChanges">
      <h3>Re-upload {{ item.videoType | enumString: runningDirection }} Video with next changes:</h3>
      <ul>
        <li *ngFor="let change of item.proposedChanges">
          {{ change }}
        </li>
      </ul>
    </div>
  </div>

  <!--IN PROGRESS-->
  <div *ngIf="analysis.status != assessmentAiStatus.Completed && analysis.status != assessmentAiStatus.Failed" class="cs_main cs_bg">
    <div class="cs_tile light">
      <h2>Processing...</h2>
    </div>
  </div>

  <!--COMPLETED-->
  <div *ngIf="analysis.status == assessmentAiStatus.Completed" class="cs_main cs_bg">
    <div class="cs_tile light">
      <h2>Summary</h2>
      <p>
        <strong> {{getHookDescription()}}</strong><br>
        Understanding your running form is the secret to running faster and staying injury-free! Your <strong>{{getGeneralScoreLevel()}}</strong> score shows how your form influences both your speed
        and injury risk.<br>
        The good news? Running form is highly trainable and even small changes can make
        a big difference! As <strong>{{getCategoryInSummary() }}</strong>, you can quickly improve by
        <strong>{{getCue()}}</strong>. For personalized exercises designed to improve your form, select
        <a href="#" (click)="scrollToSection($event, 'free-plan')">Get My Free Plan</a> and unlock your full running potential!
      </p>
    </div>
    <div class="cs_grid summary">
      <div class="cs_tile cs_text-center light">
        <div class="cs_tile-header">
          <div class="cs_score large s-{{getGeneralScoreClass()}}">
            <span>{{analysis.score | number: '1.1-1'}}%</span>
          </div>
        </div>
        <h2>RunDNA Running Score</h2>
        <p>
          {{getGeneralScoreDescription()}}
        </p>
        <button class="cs_btn" (click)="showScoreDescription()">
          Read More
        </button>
      </div>

      <div class="cs_tile cs_text-center light">
        <div class="cs_tile-header">
          <img src="../../../../assets/img/assessment/{{getCategoryImage()}}" />
        </div>
        <h2>Category: {{analysis.impairmentCategory | enumString: impairmentCategoryEnum }}</h2>
        <p>
          {{getCategoryDescription()}}
        </p>
        <button class="cs_btn" (click)="showCategoryDescription()">
          Read More
        </button>
      </div>
    </div>

    <div class="cs_table-stats">
      <div class="cs_table-row">
        <div class="cs_col">
          <div class="cs_label">General Form</div>
          <div class="cs_score s-{{ analysis.generalForm.left | enumString: categoryScoreEnum | lowercase }}"> {{overrideScore(analysis.generalForm.left | enumString: categoryScoreEnum)}}
            <div class="cs_label">Left</div>
          </div>
        </div>
        <div class="cs_col"><!-- placehodler --></div>
        <div class="cs_col">
          <div class="cs_score s-{{ analysis.generalForm.right | enumString: categoryScoreEnum | lowercase }}"> {{overrideScore(analysis.generalForm.right | enumString: categoryScoreEnum)}}
            <div class="cs_label">Right</div>
          </div>
          <button (click)="showFormDescription('General')" class="cs_btn">
            Details
          </button>
        </div>
      </div>

      <div class="cs_table-row">
        <div class="cs_col">
          <div class="cs_label">Pelvis</div>
          <div class="cs_score s-{{ analysis.pelvis.left | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.pelvis.left | enumString: categoryScoreEnum)}}</div>
        </div>
        <div class="cs_col"><!-- placeholder--></div>
        <div class="cs_col">
          <div class="cs_score s-{{ analysis.pelvis.right | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.pelvis.right | enumString: categoryScoreEnum)}}</div>
          <button (click)="showFormDescription('Pelvis')" class="cs_btn">
            Details
          </button>
        </div>
      </div>

      <div class="cs_table-row">
        <div class="cs_col">
          <div class="cs_label">Hips</div>
          <div class="cs_score s-{{ analysis.hip.left | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.hip.left | enumString: categoryScoreEnum)}}</div>
        </div>
        <div class="cs_col">
          <img class="cs_image-human" src="../../../../assets/img/assessment/human.png" />
        </div>
        <div class="cs_col">
          <div class="cs_score s-{{ analysis.hip.right | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.hip.right | enumString: categoryScoreEnum)}}</div>
          <button (click)="showFormDescription('Hips')" class="cs_btn">
            Details
          </button>
        </div>
      </div>

      <div class="cs_table-row">
        <div class="cs_col">
          <div class="cs_label">Knees</div>
          <div class="cs_score s-{{ analysis.knee.left | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.knee.left | enumString: categoryScoreEnum)}}</div>
        </div>
        <div class="cs_col"><!-- placeholder--></div>
        <div class="cs_col">
          <div class="cs_score s-{{ analysis.knee.right | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.knee.right | enumString: categoryScoreEnum)}}</div>
          <button (click)="showFormDescription('Knees')" class="cs_btn">
            Details
          </button>
        </div>
      </div>

      <div class="cs_table-row">
        <div class="cs_col">
          <div class="cs_label">Ankle</div>
          <div class="cs_score s-{{ analysis.ankles.left | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.ankles.left | enumString: categoryScoreEnum)}}</div>
        </div>
        <div class="cs_col"><!-- placeholder--></div>
        <div class="cs_col">
          <div class="cs_score s-{{ analysis.ankles.right | enumString: categoryScoreEnum | lowercase }}">{{overrideScore(analysis.ankles.right | enumString: categoryScoreEnum)}}</div>
          <button (click)="showFormDescription('Ankles')" class="cs_btn">
            Details
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="cs_grid" *ngIf="analysis.status == assessmentAiStatus.Completed">
    <div class="cs_tile cs_content-center">
      <div class="cs_score_description">
        <div class="cs_score_container">
          <div class="cs_score s-g">e</div>
          Excellent
        </div>

        <div class="cs_score_container">
          <div class="cs_score s-gf">g</div>
          Good
        </div>

        <div class="cs_score_container">
          <div class="cs_score s-f">f</div>
          Fair
        </div>
        <div class="cs_score_container">
          <div class="cs_score s-p">p</div>
          Poor
        </div>
      </div>

      <div class="cs_preview-container">
        <div class="cs_preview-item" (click)="showBackVideo()">
          <img src="../../../../assets/img/assessment/back-video-image.png"
               alt=""
               class="cs_preview-cover" />
          <div class="cs_preview-icon">
            <svg width="73"
                 height="73"
                 viewBox="0 0 73 73"
                 fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path d="M36.5 1.82495C17.374 1.82495 1.82501 17.374 1.82501 36.5C1.82501 55.6259 17.374 71.1749 36.5 71.1749C55.626 71.1749 71.175 55.6259 71.175 36.5C71.175 17.374 55.626 1.82495 36.5 1.82495Z"
                    fill="#292B2C" />
              <path d="M69.1746 36.4998C69.1745 18.4784 54.5212 3.82495 36.4998 3.82495C18.4785 3.82506 3.82512 18.4785 3.82501 36.4998C3.82501 54.5211 18.4785 69.1745 36.4998 69.1746V71.1746C17.3739 71.1745 1.82501 55.6257 1.82501 36.4998C1.82512 17.3739 17.374 1.82506 36.4998 1.82495C55.6258 1.82495 71.1745 17.3738 71.1746 36.4998C71.1746 55.6258 55.6258 71.1746 36.4998 71.1746V69.1746C54.5212 69.1746 69.1746 54.5212 69.1746 36.4998Z"
                    fill="white" />
              <path d="M48.034 34.675L31.171 23.433C29.711 22.4838 27.813 23.5059 27.813 25.258V47.742C27.813 49.494 29.7839 50.5161 31.171 49.567L48.034 38.325C49.3481 37.4491 49.3481 35.5508 48.0342 34.675H48.034Z"
                    fill="white" />
            </svg>
          </div>
          <div class="cs_label">Back Video</div>
        </div>
        <div class="cs_preview-item" (click)="showSideVideo()">
          <img src="../../../../assets/img/assessment/side-video-image.png"
               alt=""
               class="cs_preview-cover" />
          <div class="cs_preview-icon">
            <svg width="73"
                 height="73"
                 viewBox="0 0 73 73"
                 fill="none"
                 xmlns="http://www.w3.org/2000/svg">
              <path d="M36.5 1.82495C17.374 1.82495 1.82501 17.374 1.82501 36.5C1.82501 55.6259 17.374 71.1749 36.5 71.1749C55.626 71.1749 71.175 55.6259 71.175 36.5C71.175 17.374 55.626 1.82495 36.5 1.82495Z"
                    fill="#292B2C" />
              <path d="M69.1746 36.4998C69.1745 18.4784 54.5212 3.82495 36.4998 3.82495C18.4785 3.82506 3.82512 18.4785 3.82501 36.4998C3.82501 54.5211 18.4785 69.1745 36.4998 69.1746V71.1746C17.3739 71.1745 1.82501 55.6257 1.82501 36.4998C1.82512 17.3739 17.374 1.82506 36.4998 1.82495C55.6258 1.82495 71.1745 17.3738 71.1746 36.4998C71.1746 55.6258 55.6258 71.1746 36.4998 71.1746V69.1746C54.5212 69.1746 69.1746 54.5212 69.1746 36.4998Z"
                    fill="white" />
              <path d="M48.034 34.675L31.171 23.433C29.711 22.4838 27.813 23.5059 27.813 25.258V47.742C27.813 49.494 29.7839 50.5161 31.171 49.567L48.034 38.325C49.3481 37.4491 49.3481 35.5508 48.0342 34.675H48.034Z"
                    fill="white" />
            </svg>
          </div>
          <div class="cs_label">Side Video</div>
        </div>
      </div>
    </div>
    <section id="free-plan">
      <div class="cs_tile dark cs_content-center cs_text-center">
        <h1>What's next?</h1>
        <p>
          We created a plan to help you improve your running form with a
          focus on <strong>{{getCue()}}</strong>. Click below for your personalized exercises!
        </p>
        <button class="cs_btn lg" (click)="goToFreePlan()">Get My Free Plan</button>
      </div>
    </section>
  </div>
</div>
